var render = function render(){var _vm=this,_c=_vm._self._c;return _c('SidebarModal',{attrs:{"modal":_vm.modal}},[_c('ImageZoom',{staticClass:"bg-gray-100 dark:bg-neutral-900/90",attrs:{"src":_vm.modal?.payload?.default_url}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }